<template>
	<div>
		<el-row class="navbar">
			<el-col :span="8">
				<div class="grid-content bg-purple">
					<a class="navbar-brand" href="#" @click="jumpTo('gsjj')">
						<h4>海卓水信科技有限公司</h4>
						<h5>Hydrogroup Technology Co., Ltd </h5>
					</a>
				</div>
			</el-col>
			<el-col v-for="(item, index) in navigationItems" :key="index" :span="3" style="height: 100%;">
				<div class="grid-content bg-purple-light top-navigation">
					<a href="#" class="link-top-nav first watch-trailer" :class="{ 'active': item.active }"
						@mouseenter.prevent="startSpan(index)" @mouseleave="endSpan(index)" @click="jumpTo(item.route)">
						<span class="top-navigation-text intro-animation"
							:style="{ opacity: 1, transform: 'translate3d(0px, 0px, 0px)' }">
							{{ item.label }}
						</span>

						<audio :id="'move' + index" ref="audioRefs" :src="mp3src" controls style="display:none;"
							autoplay muted></audio>

						<span class="navigation-strip navigation-strip-1">
							<span class="strip-inside-wrapper" :class="{ 'action1': item.show, 'levaction': item.flag }"
								:style="{ opacity: 0, transform: `translate3d(${item.show ? '-173px' : '0px'}, 0px, 0px)` }">
								<span class="strip-inside"></span>
							</span>
						</span>

						<span class="navigation-strip navigation-strip-2">
							<span class="strip-inside-wrapper" :class="{ 'action2': item.show }"
								:style="{ transform: `translate3d(${item.show ? '-174px' : '0px'}, 0px, 0px)` }">
								<span class="strip-inside"></span>
							</span>
						</span>
					</a>
				</div>
			</el-col>
			<el-col :span="7">
				<div class="grid-content bg-purple">
					<el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
						<div class="avatar-wrapper">
							<i class="el-icon-user-solid" />
						</div>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item divided @click.native="logout">
								<span>退出登录</span>
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				mp3src: require('@/assets/mp3/20220801_174804.mp3'),
				navigationItems: [{
						label: '公司简介',
						show: false,
						flag: false,
						active: true,
						route: 'gsjj'
					},
					{
						label: '方案介绍',
						show: false,
						flag: false,
						active: false,
						route: 'fajs'
					},
					{
						label: '案例介绍',
						show: false,
						flag: false,
						active: false,
						route: 'main'
					}
				]
			};
		},
		methods: {
			jumpTo(param) {
				this.$emit('navData', param);
				console.log(param);
			},
			startSpan(index) {
				this.navigationItems.forEach((item, idx) => {
					item.active = idx === index; // 只有当前按钮被点击时，`active` 为 true
				});
				// 只修改当前按钮的 show 和 flag 状态
				this.navigationItems[index].show = true;
				this.navigationItems[index].flag = false;

				// 播放当前按钮的音频
				const audio = this.$refs.audioRefs[index];
				if (audio) {
					audio.currentTime = 0; // 从头开始播放
					audio.play();
				}
			},
			endSpan(index) {
				// 只修改当前按钮的 show 和 flag 状态
				this.navigationItems[index].show = false;
				this.navigationItems[index].flag = true;
			},
			logout() {
				this.$router.replace('/');
			}
		}
	};
</script>

<style scoped="scoped">
	@font-face {
		font-family: "HYDaHeiJ";
		src: url("../../assets/font/HYDaHeiJ.ttf");
	}

	@font-face {
		font-family: "PingFang-SC-Semibold-2";
		src: url("../../assets/font/PingFang-SC-Semibold-2.ttf");
	}

	.navbar-brand {
		height: 100%;
		text-decoration: none;
	}

	.navbar-brand h4 {
		width: 100%;
		height: 40px;
		text-align: left;
		font-size: 17px;
		font-family: HYDaHeiJ;
		font-weight: 550;
		color: #FFFFFF;
		line-height: 40px;
		letter-spacing: 5px;
	}

	.navbar-brand h5 {
		width: 304px;
		height: 20px;
		font-size: 10px;
		font-family: HYDaHeiJ;
		font-weight: 400;
		color: #FFFFFF;
		line-height: 6px;
		text-align: left;
	}

	.top-navigation {
		text-align: left;
		line-height: 60px;
		vertical-align: middle;
	}

	.top-navigation a {
		height: 20px;
		line-height: 20px;
		position: relative;
		display: inline-block;
		vertical-align: middle;
		/* padding: 3px 12px; */
		text-decoration: none;
	}

	.top-navigation a .top-navigation-text {
		position: relative;
		display: inline-block;
		opacity: 0;
		-webkit-transform: translate3d(0, -40px, 0);
		-moz-transform: translate3d(0, -40px, 0);
		-ms-transform: translate3d(0, -40px, 0);
		-o-transform: translate3d(0, -40px, 0);
		transform: translate3d(0, -40px, 0);
		font-family: 'BentonSans-Black';
		font-size: 14px;
		text-transform: uppercase;
		text-decoration: none;
		color: #fff;
		letter-spacing: 2px;
	}

	@media screen and (max-width: 767px) {
		.top-navigation a .top-navigation-text {
			font-size: 9px;
		}
	}

	@media screen and (max-width: 550px) {
		.top-navigation a .top-navigation-text {
			font-size: 8px;
		}
	}

	.top-navigation a .navigation-strip {
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		-webkit-transform: skew(-25deg);
		-moz-transform: skew(-25deg);
		-ms-transform: skew(-25deg);
		-o-transform: skew(-25deg);
		transform: skew(-25deg);
		overflow: hidden;
	}

	.top-navigation a .navigation-strip .strip-inside-wrapper {
		display: inline-block;
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		opacity: 1;
		transform: translateX(-105%);
	}

	.top-navigation a .navigation-strip .strip-inside-wrapper .strip-inside {
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		right: 0;
	}

	.top-navigation a .navigation-strip.navigation-strip-1 .strip-inside {
		background-color: #fff;
	}

	.top-navigation a .navigation-strip.navigation-strip-2 .strip-inside {
		background-color: #2fa3c7;
	}

	.top-navigation a.watch-trailer {
		width: 85px;
	}

	.top-navigation a.watch-trailer .navigation-strip .strip-inside-wrapper .strip-inside {
		width: 8px;
	}

	@media screen and (max-width: 1024px) and (min-width: 821px) {
		.top-navigation {
			left: initial;
			right: 128px;
			-webkit-transform: none;
			-moz-transform: none;
			-ms-transform: none;
			-o-transform: none;
			transform: none;
		}
	}

	@media screen and (min-width: 821px) {
		.top-navigation a {
			opacity: 1 !important;
		}
	}

	@media screen and (max-width: 820px) {
		.top-navigation {
			display: none;
			top: 11%;
		}

		.top-navigation a {
			opacity: 0;
		}

		.top-navigation.active {
			display: block;
		}
	}

	@media screen and (max-width: 400px) {
		.top-navigation {
			top: 15%;
		}

		.top-navigation a span {
			font-size: 8px;
		}

		.top-navigation.active {
			display: block;
		}
	}

	.navigation-strip .strip-inside-wrapper {
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		-webkit-transform: translateX(-105%);
		-moz-transform: translateX(-105%);
		-ms-transform: translateX(-105%);
		-o-transform: translateX(-105%);
	}

	.navigation-strip .levaction {
		animation-fill-mode: forwards;
	}

	.navigation-strip .action1 {
		animation: moveStrip1 0.3s ease-in-out;
		animation-fill-mode: forwards;
	}

	.navigation-strip .action2 {
		animation: moveStrip1 0.5s ease-in-out;
		animation-fill-mode: forwards;
	}

	@keyframes moveStrip1 {
		0% {
			opacity: 0;
			transform: translate3d(-172.3px, 0px, 0px);
		}

		100% {
			opacity: 1;
			transform: translate3d(0px, 0px, 0px);
		}
	}

	@keyframes levaction {
		0% {
			opacity: 1;
			transform: translate3d(30px, 0px, 0px);
		}

		100% {
			opacity: 0;
			transform: translate3d(-172.3px, 0px, 10px);
		}
	}

	.right-menu-item {
		float: right;
	}

	.avatar-wrapper {
		line-height: 50px;
		padding: 10px 10px 0px 0;
	}

	.avatar-wrapper i {
		display: inline-block;
		color: #27E2FE;
		width: 30px;
		height: 30px;
		font-size: 30px;
	}

	.link-top-nav.active {
		font-weight: bold;
		/* 修改选中后的字体粗细 */
	}
</style>


// WEBPACK FOOTER //
// src/components/views/Header.vue